import type { AxiosResponse } from 'axios'
import { httpClient } from 'shared/api/http-client'

export const regenerateJWT = (): Promise<AxiosResponse> =>
  httpClient.post('/api/user/token/regenerate')
